
import { MonthlySales } from "../Model/Metric";
import { MetricRepository } from "../Repository/MetricRepository";

export interface GetMonthlySalesUseCase {
  invoke:(year: number) => Promise<MonthlySales[]>;
}

export class GetMonthlySales implements GetMonthlySalesUseCase {
  private repo: MetricRepository;
  constructor(_repo: MetricRepository) {
    this.repo = _repo;
  }

  async invoke(year: number){
     
    const getData = await this.repo.getMonthlySales(year);
    return getData;
  }
}